import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

type SectionProps = IThemeProps<{ isCorrect?: boolean }>;
export const Section = styled.section<SectionProps>`
  display: block;
  margin: 0 auto;
  width: 100%;
  background-color: ${(props: SectionProps) =>
    props.isCorrect ? props.theme.colors.success : props.theme.colors.error};
`;

export const Wrapper = styled.div<IThemeProps>`
  display: flex;
  height: 100%;
  min-height: ${(props: IThemeProps) =>
    props.theme.globals.minInteractionHeight};
  align-items: center;
  justify-content: center;
  flex-flow: column;
  padding: 20px;
`;

type TitleProps = IThemeProps<{}>;
export const Title = styled.h3<TitleProps>`
  display: block;
  margin: 0 auto;
  text-transform: uppercase;
  text-align: center;
  font-size: ${(props: TitleProps) => props.theme.typography.h700};
  font-weight: ${(props: TitleProps) => props.theme.typography.h300};
  color: ${(props: TitleProps) => props.theme.colors.white};
`;

type ContentBoxProps = IThemeProps<{}>;
export const ContentBox = styled.div<ContentBoxProps>`
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: ${(props: ContentBoxProps) => props.theme.colors.white};
  margin-top: ${(props: ContentBoxProps) => props.theme.spacing.desktop.s400}px;
`;

type TextProps = IThemeProps<{}>;
export const Text = styled.p<TextProps>`
  display: block;
  margin: 0 auto;
  text-align: center;
  font-size: ${(props: any) => props.theme.typography.h600};
`;

type ButtonWrapProps = IThemeProps<{}>;
export const ButtonWrap = styled.div<ButtonWrapProps>`
  display: block;
  margin: 0 auto;
  margin-top: ${(props: ContentBoxProps) => props.theme.spacing.desktop.s400}px;
`;

type ImageProps = IThemeProps<{ showOnlyImage: boolean }>;
export const Image = styled.img<ImageProps>`
  position: relative;
  display: block;
  margin: 0 auto;
  overflow: hidden;

  background-color: ${(props: any) => props.theme.colors.white};
  border-color: ${(props: any) => props.theme.colors.white};
  border-style: solid;
  border-width: ${(props: any) => props.theme.borders.imageTile};
  box-shadow: ${(props: any) => props.theme.shadows.s200};
  width: 100%;
  height: auto;

  margin-top: ${(props: ImageProps) => (props.showOnlyImage ? "0" : "18px")};
`;
